/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../nb');
var submitEmail = require('../../../io/' + process.env.APP_ENV + '/index/submitEmail'); //提交邮箱
var emailValue;
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            var self = this;

            //提交邮箱
            this.onChange('requireSubmitEmail', function () {
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                emailValue = this.get('emailValue') || '';
                if (!emailValue && emailValue.trim().length == 0) {  //没有value 无评论
                    nb.toast.setOpts({
                        text: this.get('emailToast1'),//请填写邮箱！
                        status: 'danger'
                    });
                    return;
                }
                if (reg.test(emailValue)) {
                    this.submitEmail();
                } else {
                    nb.toast.setOpts({
                        text: this.get('emailToast2'),//请填写有效邮箱
                        status: 'danger'
                    });
                    return;
                }
            }, this)


        },

        //提交邮箱
        submitEmail: function () {
            submitEmail({
                data: {
                    email: emailValue
                },
                scope: this,
                success: function (inResp) {
                    nb.toast.setOpts({
                        text: inResp.msg,
                        status: 'success',
                        duration: 1
                    });
                }
            })
        }

    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/Bottom.js
// module id = 538
// module chunks = 6